import { createTheme } from '@one-thd/sui-atomic-components';

const LightKhakiTheme = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

LightKhakiTheme.palette['--sui-palette-background-primary'] = '238 226 215';

export { LightKhakiTheme };